import { Injectable }    from '@angular/core';

import { Holiday } from '../../classes/holiday';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

@Injectable()
export class HolidayService extends UserService {

  constructor(
    protected requestService: RequestService, 
    protected auth: Auth
  ) { super(requestService, auth); }

  protected getUsersUrl(): string {

    return 'holidays';
  };

  protected getOneUserUrl(): string {

    return 'holiday';
  };

  protected parseObject(obj: any): Holiday {

    return obj as Holiday;
  };

  protected parseArray(objs: any): Holiday[] {

    return objs as Holiday[];
  };

}


// WEBPACK FOOTER //
// ./src/app/services/holidays/holiday.service.ts